export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/JM-d7ba224599e6cc19cbf4ea7d0b54998b.png";